@if (config) {
  <ul class="lang" [ngClass]="'lang--' + mode">
    @for (lang of config; track lang) {
      <li class="lang__item" [ngClass]="getClasses('lang__item', lang.iso)">
        <button
          class="lang__btn"
          [ngClass]="getClasses('lang__btn', lang.iso)"
          [attr.aria-label]="lang.label"
          (click)="setLanguage(lang)"
        >
          @switch (mode) {
            @case ('tab') {
              <span class="t-bold">{{ lang.abbv }}</span>
            }
            @default {
              {{ lang.label }}
            }
          }
        </button>
      </li>
    }
  </ul>
}
